<template>
  <form method="post" :action="action" class="text-left my-4">
    <input
      v-if="
        invoice.is_initial_invoice ||
          invoice.is_initial_deposit ||
          invoice.is_management_fees ||
          isRentFromStatus ||
          invoice.created_from === 'hotel_placement'
      "
      type="hidden"
      name="invoice[amount]"
      v-model="totalAmount"
    />

    <div class="row mb-4 text-sm">
      <div class="col-12 col-md-6">
        <div class="form-row mb-2">
          <div class="col">
            <div class="form-group">
              <label class="form-control-wrap">Policyholder Name</label>
              <div class="form-control-wrap">
                {{ placement.policyholder.name ? placement.policyholder.name : "-" }}
              </div>
            </div>
          </div>
        </div>

        <div class="form-row mb-2">
          <div class="col">
            <div class="form-group">
              <label class="form-control-wrap">Public Adjuster</label>
              <div class="form-control-wrap">
                {{ adjusters.public_adjuster && adjusters.public_adjuster.contact_data ? adjusters.public_adjuster.contact_data.name : "-" }}
              </div>
            </div>
          </div>
        </div>

        <div class="form-row">
          <div class="col">
            <div class="form-group">
              <label class="form-control-wrap">Public Adjuster Company</label>
              <div class="form-control-wrap">
                {{ adjusters.public_adjuster && adjusters.public_adjuster.company_data ? adjusters.public_adjuster.company_data.name : "-" }}
              </div>
            </div>
          </div>
        </div>

        <div class="form-row" v-if="placement.loss_address && placement.loss_address.full_address">
          <div class="col">
            <div class="form-group">
              <label class="form-control-wrap">Loss Address</label>
              <div class="form-control-wrap">
                {{ placement.loss_address.full_address }}
              </div>
            </div>
          </div>
        </div>

        <div class="form-row" v-if="property && property.address && property.address.full_address">
          <div class="col">
            <div class="form-group">
              <label class="form-control-wrap">Relocation Address</label>
              <div class="form-control-wrap">
                {{ property.address.full_address }}
              </div>
            </div>
          </div>
        </div>

        <div class="form-row mb-5"></div>

        <div class="form-row mb-2" v-if="invoice.created_from === 'hotel_placement'">
          <div class="col">
            <div class="form-group">
              <span class="text-sm form-control-wrap font-weight-bold">Hotel Name</span>
              <div class="form-control-wrap text-sm ml-3 justify-content-between">
                <strong>{{ hotel.name || "-" }}</strong>
              </div>
            </div>
          </div>
        </div>

        <template v-if="rentItems.length">
          <div class="form-row mb-4 text-sm">
            <div class="col">
              <div class="form-group">
                <span class="form-control-wrap font-weight-bold">
                  Rent
                  <i
                    class="recalculate-mmf fa fa-sync px-3"
                    data-toggle="tooltip"
                    data-placement="top"
                    :title="`Recalculate rent ${this.showManagementFees ? 'and management ' : ''}fees`"
                    style="cursor: pointer;"
                    @click="recalculateMmf"
                  ></i>
                </span>
                <div class="row"><div class="col-12 qb-label">QB Type</div></div>

                <div class="form-control-wrap justify-content-between ml-3" v-for="(item, index) in temp.rents" :key="index">
                  <div class="row align-items-center position-relative">
                    <button
                      v-if="!isRentFromStatus"
                      type="button"
                      class="btn btn-danger btn-slim btn-sm mx-1 position-absolute"
                      style="right: 100%;"
                      @click="removeAdditionalLineItem(index)"
                    >
                      <i class="fa fa-times"></i>
                    </button>
                    <div class="col-12 col-md-9 d-flex flex-wrap flex-md-nowrap align-items-center px-0">
                      <span v-html="generateQBSelectionField(`${item.type}_${index}`)"></span>
                      <strong v-if="isRentFromStatus">{{ item.name }}</strong>
                      <input v-if="isRentFromStatus" v-model="item.name" type="hidden" :name="`rent_items[${index}][name]`" />
                      <v-text
                        v-else
                        v-model="item.name"
                        class="form-control alphanumeric-field "
                        autocomplete="off"
                        :name="`rent_items[${index}][name]`"
                      ></v-text>
                      <span class="pr-2">:</span>
                      <div class="d-flex justify-content-center align-items-center">
                        <div class="d-flex justify-content-center align-items-center">
                          <div class="form-control-wrap form-datepicker">
                            <v-datepicker
                              type="text"
                              v-model="item.start_date"
                              :name="`rent_items[${index}][start_date]`"
                              autocomplete="off"
                              class="form-control datepicker text-center"
                              pattern="(0[1-9]|1[012])[- /.](0[1-9]|[12][0-9]|3[01])[- /.](18|19|20)\d\d"
                              @input="calculateProrationAmount(item.start_date, item.end_date, index)"
                            >
                            </v-datepicker>
                          </div>
                        </div>
                        <span class="px-1"> - </span>
                        <div class="d-flex justify-content-center align-items-center">
                          <div class="form-control-wrap form-datepicker">
                            <v-datepicker
                              type="text"
                              v-model="item.end_date"
                              :name="`rent_items[${index}][end_date]`"
                              autocomplete="off"
                              class="form-control datepicker text-center"
                              pattern="(0[1-9]|1[012])[- /.](0[1-9]|[12][0-9]|3[01])[- /.](18|19|20)\d\d"
                              @input="calculateProrationAmount(item.start_date, item.end_date, index)"
                            >
                            </v-datepicker>
                          </div>
                        </div>
                      </div>
                      <strong class="text-nowrap px-1">({{ calculateDays(item.start_date, item.end_date) }})</strong>
                    </div>
                    <div class="col-12 col-md-3">
                      <div class="form-control-wrap form-control-currency">
                        <i class="fas fa-dollar-sign"></i>
                        <input type="hidden" :name="`rent_items[${index}][type]`" value="rent" />
                        <v-currency
                          :is-blank="false"
                          type="text"
                          class="form-control text-right"
                          :name="`rent_items[${index}][amount]`"
                          v-model="item.amount"
                        ></v-currency>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </template>

        <template v-if="invoice.is_initial_invoice">
          <div class="form-row mb-4 text-sm" v-show="hasFees">
            <div class="col-12">
              <span class="form-control-wrap font-weight-bold">Fees & Deposits</span>
            </div>
            <div class="col-12">
              <div class="qb-label">QB Type</div>
            </div>
            <div class="col-12">
              <div
                class="row ml-1 mb-2 mb-md-0 align-items-center justify-content-between position-relative"
                v-show="feesAndDeposits.cleaning_fee > 0 || isAdded('cleaning_fee')"
              >
                <button
                  type="button"
                  class="btn btn-danger btn-slim btn-sm mx-1 position-absolute"
                  style="right: 100%;"
                  @click="toggleField('cleaning_fee', true)"
                >
                  <i class="fa fa-times"></i>
                </button>
                <div class="col-auto no-left-padding">
                  <span v-html="generateQBSelectionField('cleaning_fee')"></span>
                  <strong>Lease Cleaning Fee</strong>
                </div>
                <div class="col-12 col-md-3">
                  <div class="form-control-wrap form-control-currency">
                    <i class="fas fa-dollar-sign"></i>
                    <v-currency
                      :is-blank="false"
                      type="text"
                      class="form-control text-right"
                      name="budget[cleaning_fee]"
                      v-model="budget.cleaning_fee"
                    ></v-currency>
                    <v-checkbox
                      v-model="budget.cleaning_fee_first_payment"
                      class="form-check-input"
                      name="budget[cleaning_fee_first_payment]"
                    ></v-checkbox>
                  </div>
                </div>
              </div>

              <div
                class="row ml-1 mb-2 mb-md-0 align-items-center justify-content-between position-relative"
                v-show="feesAndDeposits.application_fee > 0 || isAdded('application_fee')"
              >
                <button
                  type="button"
                  class="btn btn-danger btn-slim btn-sm mx-1 position-absolute"
                  style="right: 100%;"
                  @click="toggleField('application_fee', true)"
                >
                  <i class="fa fa-times"></i>
                </button>
                <div class="col-auto no-left-padding">
                  <span v-html="generateQBSelectionField('application_fee')"></span>
                  <strong>Lease App Fee</strong>
                </div>
                <div class="col-12 col-md-3">
                  <div class="form-control-wrap form-control-currency">
                    <i class="fas fa-dollar-sign"></i>
                    <v-currency
                      :is-blank="false"
                      type="text"
                      class="form-control text-right"
                      name="budget[application_fee]"
                      v-model="budget.application_fee"
                    ></v-currency>
                    <v-checkbox
                      v-model="budget.application_fee_first_payment"
                      class="form-check-input"
                      name="budget[application_fee_first_payment]"
                    ></v-checkbox>
                  </div>
                </div>
              </div>

              <div
                class="row ml-1 mb-2 mb-md-0 align-items-center justify-content-between position-relative"
                v-show="feesAndDeposits.pet_fee > 0 || isAdded('pet_fee')"
              >
                <button
                  type="button"
                  class="btn btn-danger btn-slim btn-sm mx-1 position-absolute"
                  style="right: 100%;"
                  @click="toggleField('pet_fee', true)"
                >
                  <i class="fa fa-times"></i>
                </button>
                <div class="col-auto no-left-padding">
                  <span v-html="generateQBSelectionField('pet_fee')"></span>
                  <strong>Lease Pet Fee</strong>
                </div>
                <div class="col-12 col-md-3">
                  <div class="form-control-wrap form-control-currency">
                    <i class="fas fa-dollar-sign"></i>
                    <v-currency
                      :is-blank="false"
                      type="text"
                      class="form-control text-right"
                      name="budget[pet_fee]"
                      v-model="budget.pet_fee"
                    ></v-currency>
                    <v-checkbox v-model="budget.pet_fee_first_payment" class="form-check-input" name="budget[pet_fee_first_payment]"></v-checkbox>
                  </div>
                </div>
              </div>

              <div
                class="row ml-1 mb-2 mb-md-0 align-items-center justify-content-between position-relative"
                v-show="feesAndDeposits.misc_fee > 0 || isAdded('misc_fee')"
              >
                <button
                  type="button"
                  class="btn btn-danger btn-slim btn-sm mx-1 position-absolute"
                  style="right: 100%;"
                  @click="toggleField('misc_fee', true)"
                >
                  <i class="fa fa-times"></i>
                </button>
                <div class="col-auto no-left-padding">
                  <span v-html="generateQBSelectionField('misc_fee')"></span>
                  <strong>Misc Fees</strong>
                </div>
                <div class="col-12 col-md-3">
                  <div class="form-control-wrap form-control-currency">
                    <i class="fas fa-dollar-sign"></i>
                    <v-currency
                      :is-blank="false"
                      type="text"
                      class="form-control text-right"
                      name="budget[misc_fee]"
                      v-model="budget.misc_fee"
                    ></v-currency>
                    <v-checkbox v-model="budget.misc_fee_first_payment" class="form-check-input" name="budget[misc_fee_first_payment]"></v-checkbox>
                  </div>
                </div>
              </div>

              <div
                class="row ml-1 mb-2 mb-md-0 align-items-center justify-content-between position-relative"
                v-show="feesAndDeposits.furniture_cleaning_fee > 0 || isAdded('furniture_cleaning_fee')"
              >
                <button
                  type="button"
                  class="btn btn-danger btn-slim btn-sm mx-1 position-absolute"
                  style="right: 100%;"
                  @click="toggleField('furniture_cleaning_fee', true)"
                >
                  <i class="fa fa-times"></i>
                </button>
                <div class="col-auto no-left-padding">
                  <span v-html="generateQBSelectionField('furniture_cleaning_fee')"></span>
                  <strong>Furniture Cleaning Fee</strong>
                </div>
                <div class="col-12 col-md-3">
                  <div class="form-control-wrap form-control-currency">
                    <i class="fas fa-dollar-sign"></i>
                    <v-currency
                      :is-blank="false"
                      type="text"
                      class="form-control text-right"
                      name="budget[furniture_cleaning_fee]"
                      v-model="budget.furniture_cleaning_fee"
                    ></v-currency>
                  </div>
                </div>
              </div>

              <div
                class="row ml-1 mb-2 mb-md-0 align-items-center justify-content-between position-relative"
                v-show="feesAndDeposits.furniture_delivery_fee > 0 || isAdded('furniture_delivery_fee')"
              >
                <button
                  type="button"
                  class="btn btn-danger btn-slim btn-sm mx-1 position-absolute"
                  style="right: 100%;"
                  @click="toggleField('furniture_delivery_fee', true)"
                >
                  <i class="fa fa-times"></i>
                </button>
                <div class="col-auto no-left-padding">
                  <span v-html="generateQBSelectionField('furniture_delivery_fee')"></span>
                  <strong>Furniture Delivery Fee</strong>
                </div>
                <div class="col-12 col-md-3">
                  <div class="form-control-wrap form-control-currency">
                    <i class="fas fa-dollar-sign"></i>
                    <v-currency
                      :is-blank="false"
                      type="text"
                      class="form-control text-right"
                      name="budget[furniture_delivery_fee]"
                      v-model="budget.furniture_delivery_fee"
                    ></v-currency>
                  </div>
                </div>
              </div>

              <div
                class="row ml-1 mb-2 mb-md-0 align-items-center justify-content-between position-relative"
                v-show="feesAndDeposits.one_time_admin_fee > 0 || isAdded('one_time_admin_fee')"
              >
                <button
                  type="button"
                  class="btn btn-danger btn-slim btn-sm mx-1 position-absolute"
                  style="right: 100%;"
                  @click="toggleField('one_time_admin_fee', true)"
                >
                  <i class="fa fa-times"></i>
                </button>
                <div class="col-auto no-left-padding">
                  <span v-html="generateQBSelectionField('one_time_admin_fee')"></span>
                  <strong>One Time Admin Fee</strong>
                </div>
                <div class="col-12 col-md-3">
                  <div class="form-control-wrap form-control-currency">
                    <i class="fas fa-dollar-sign"></i>
                    <v-currency
                      :is-blank="false"
                      type="text"
                      class="form-control text-right"
                      name="budget[one_time_tps_fee]"
                      v-model="budget.one_time_tps_fee"
                    ></v-currency>
                    <v-checkbox v-model="budget.one_time_tps" class="form-check-input" name="budget[one_time_tps]"></v-checkbox>
                  </div>
                </div>
              </div>

              <div
                class="row ml-1 mb-2 mb-md-0 align-items-center justify-content-between position-relative"
                v-show="feesAndDeposits.one_time_management_fee > 0 || isAdded('one_time_management_fee')"
              >
                <button
                  type="button"
                  class="btn btn-danger btn-slim btn-sm mx-1 position-absolute"
                  style="right: 100%;"
                  @click="toggleField('one_time_management_fee', true)"
                >
                  <i class="fa fa-times"></i>
                </button>
                <div class="col-auto no-left-padding">
                  <span v-html="generateQBSelectionField('one_time_management_fee')"></span>
                  <strong>One Time Management Fee</strong>
                </div>
                <div class="col-12 col-md-3">
                  <div class="form-control-wrap form-control-currency">
                    <i class="fas fa-dollar-sign"></i>
                    <v-currency
                      :is-blank="false"
                      type="text"
                      class="form-control text-right"
                      name="budget[one_time_fee]"
                      v-model="budget.one_time_fee"
                    ></v-currency>
                    <v-checkbox v-model="budget.one_time" class="form-check-input" name="budget[one_time]"></v-checkbox>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </template>

        <template v-if="invoice.is_initial_invoice || invoice.is_initial_deposit">
          <div class="form-row mb-2" v-if="invoice.is_initial_deposit">
            <div class="col-12 text-sm">
              <div class="row align-items-center">
                <div class="col-6">
                  <strong>Dates of Invoice</strong>
                </div>
                <div class="col d-flex justify-content-center align-items-center">
                  <div class="d-flex justify-content-center align-items-center">
                    <div class="form-control-wrap form-datepicker">
                      <v-datepicker
                        type="text"
                        v-model="invoice.start_date"
                        name="invoice[start_date]"
                        autocomplete="off"
                        class="form-control datepicker text-center"
                        pattern="(0[1-9]|1[012])[- /.](0[1-9]|[12][0-9]|3[01])[- /.](18|19|20)\d\d"
                      >
                      </v-datepicker>
                    </div>
                  </div>
                  <span class="px-1"> - </span>
                  <div class="d-flex justify-content-center align-items-center">
                    <div class="form-control-wrap form-datepicker">
                      <v-datepicker
                        type="text"
                        v-model="invoice.end_date"
                        name="invoice[end_date]"
                        autocomplete="off"
                        class="form-control datepicker text-center"
                        pattern="(0[1-9]|1[012])[- /.](0[1-9]|[12][0-9]|3[01])[- /.](18|19|20)\d\d"
                      >
                      </v-datepicker>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="form-row mb-4 text-sm" v-show="hasDeposits">
            <div class="col-12">
              <span class="form-control-wrap font-weight-bold">Deposits</span>
            </div>
            <div class="col-12 qb-label">QB Type</div>
            <div class="col-12">
              <div
                class="row ml-1 align-items-start justify-content-between position-relative"
                v-show="deposits.landlord > 0 || isAdded('landlord_deposit')"
              >
                <button
                  type="button"
                  class="btn btn-danger btn-slim btn-sm mx-1 position-absolute"
                  style="right: 100%;"
                  v-if="invoice.is_initial_invoice"
                  @click="toggleField('landlord_deposit', true)"
                >
                  <i class="fa fa-times"></i>
                </button>
                <div class="col-auto no-left-padding">
                  <span v-html="generateQBSelectionField('landlord_deposit')"></span>
                  <strong>Landlord Security Deposit</strong>
                  <p class="m-0 ml-5 pl-3">
                    Paid out of <mark>{{ getPaidOutof(budget.landlord_paid_out_of) }}</mark>
                  </p>
                </div>
                <div class="col-12 col-md-3">
                  <div class="form-control-wrap form-control-currency">
                    <i class="fas fa-dollar-sign"></i>
                    <v-currency
                      :is-blank="false"
                      type="text"
                      class="form-control text-right"
                      name="budget[landlord_deposit]"
                      v-model="budget.landlord_deposit"
                    ></v-currency>
                    <v-checkbox
                      v-model="budget.landlord_deposit_first_payment"
                      class="form-check-input"
                      name="budget[landlord_deposit_first_payment]"
                    ></v-checkbox>
                    <input type="hidden" name="budget[landlord_paid_out_of]" v-model="budget.landlord_paid_out_of" />
                  </div>
                </div>
              </div>
              <div class="row ml-1 align-items-start justify-content-between position-relative" v-show="deposits.pet > 0 || isAdded('pet_deposit')">
                <button
                  type="button"
                  class="btn btn-danger btn-slim btn-sm mx-1 position-absolute"
                  style="right: 100%;"
                  v-if="invoice.is_initial_invoice"
                  @click="toggleField('pet_deposit', true)"
                >
                  <i class="fa fa-times"></i>
                </button>
                <div class="col-auto no-left-padding">
                  <span v-html="generateQBSelectionField('pet_deposit')"></span>
                  <strong>Pet Security Deposit</strong>
                  <p class="m-0 ml-5 pl-3">
                    Paid out of <mark>{{ getPaidOutof(budget.pet_paid_out_of) }}</mark>
                  </p>
                </div>
                <div class="col-12 col-md-3">
                  <div class="form-control-wrap form-control-currency">
                    <i class="fas fa-dollar-sign"></i>
                    <v-currency
                      :is-blank="false"
                      type="text"
                      class="form-control text-right"
                      name="budget[pet_deposit]"
                      v-model="budget.pet_deposit"
                    ></v-currency>
                    <v-checkbox
                      v-model="budget.pet_deposit_first_payment"
                      class="form-check-input"
                      name="budget[pet_deposit_first_payment]"
                    ></v-checkbox>
                    <input type="hidden" name="budget[pet_paid_out_of]" v-model="budget.pet_paid_out_of" />
                  </div>
                </div>
              </div>
              <div
                class="row ml-1 align-items-start justify-content-between position-relative"
                v-show="deposits.furniture > 0 || isAdded('furniture_deposit')"
              >
                <button
                  type="button"
                  class="btn btn-danger btn-slim btn-sm mx-1 position-absolute"
                  style="right: 100%;"
                  v-if="invoice.is_initial_invoice"
                  @click="toggleField('furniture_deposit', true)"
                >
                  <i class="fa fa-times"></i>
                </button>
                <div class="col-auto no-left-padding">
                  <span v-html="generateQBSelectionField('furniture_deposit')"></span>
                  <strong>Furniture Security Deposit</strong>
                  <p class="m-0 ml-5 pl-3">
                    Paid out of <mark>{{ getPaidOutof(budget.furniture_paid_out_of) }}</mark>
                  </p>
                </div>
                <div class="col-12 col-md-3">
                  <div class="form-control-wrap form-control-currency">
                    <i class="fas fa-dollar-sign"></i>
                    <v-currency
                      :is-blank="false"
                      type="text"
                      class="form-control text-right"
                      name="budget[furniture_deposit]"
                      v-model="budget.furniture_deposit"
                    ></v-currency>
                    <v-checkbox
                      v-model="budget.furniture_deposit_enable"
                      class="form-check-input"
                      name="budget[furniture_deposit_enable]"
                    ></v-checkbox>
                    <input type="hidden" name="budget[furniture_paid_out_of]" v-model="budget.furniture_paid_out_of" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </template>

        <template v-else-if="!isRentFromStatus">
          <div
            class="form-row"
            v-if="
              invoice.created_from === 'hotel_placement' &&
                invoice.invoice_requests.length &&
                !(housing_fee_type === 'Expenses' && invoice.is_management_fees)
            "
          >
            <div class="col-12 text-sm">
              <div class="row">
                <div class="col-12 qb-label">
                  QB Type
                </div>
              </div>
              <div class="row ml-1 align-items-start justify-content-between" v-for="(invoice_request, index) in invoice.invoice_requests">
                <div class="col pl-0">
                  <span v-html="generateQBSelectionField(`invoice_request_${invoice_request.id}`)"></span>
                  <v-text
                    v-model="invoice_request.what_for"
                    class="form-control alphanumeric-field "
                    autocomplete="off"
                    :name="`invoice_requests[${index}][what_for]`"
                  ></v-text>
                </div>
                <div class="col-12 col-md-3">
                  <div class="form-control-wrap form-control-currency">
                    <i class="fas fa-dollar-sign"></i>
                    <v-currency
                      :is-blank="false"
                      type="text"
                      class="form-control text-right"
                      :name="`invoice_requests[${index}][amount]`"
                      v-model="invoice_request.amount"
                      @input="() => calculatePercentage()"
                    ></v-currency>
                    <input type="hidden" :name="`invoice_requests[${index}][id]`" :value="invoice_request.id" />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <template v-else>
            <div class="form-row mb-2">
              <div class="col-12 text-sm">
                <div class="row align-items-center">
                  <div class="col-6">
                    <strong>Dates of Invoice</strong>
                    <i
                      v-if="invoice.is_management_fees"
                      class="recalculate-mmf fa fa-sync px-3"
                      data-toggle="tooltip"
                      data-placement="top"
                      title="Recalculate management fees"
                      style="cursor: pointer;"
                      @click="recalculateMmf"
                    ></i>
                  </div>
                  <div class="col d-flex justify-content-center align-items-center">
                    <div class="d-flex justify-content-center align-items-center">
                      <div class="form-control-wrap form-datepicker">
                        <v-datepicker
                          type="text"
                          v-model="invoice.start_date"
                          name="invoice[start_date]"
                          autocomplete="off"
                          class="form-control datepicker text-center"
                          pattern="(0[1-9]|1[012])[- /.](0[1-9]|[12][0-9]|3[01])[- /.](18|19|20)\d\d"
                        >
                        </v-datepicker>
                      </div>
                    </div>
                    <span class="px-1"> - </span>
                    <div class="d-flex justify-content-center align-items-center">
                      <div class="form-control-wrap form-datepicker">
                        <v-datepicker
                          type="text"
                          v-model="invoice.end_date"
                          name="invoice[end_date]"
                          autocomplete="off"
                          class="form-control datepicker text-center"
                          pattern="(0[1-9]|1[012])[- /.](0[1-9]|[12][0-9]|3[01])[- /.](18|19|20)\d\d"
                        >
                        </v-datepicker>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="form-row" v-if="!invoice.is_management_fees">
              <div class="col-12 text-sm">
                <div class="row">
                  <div class="col-12 qb-label">
                    QB Type
                  </div>
                </div>
                <div class="row ml-1 align-items-start justify-content-between">
                  <div class="col pl-0">
                    <span v-html="generateQBSelectionField(invoice.what_for.replace(/\s/g, '_').toLowerCase())"></span>
                    <strong>{{ invoice.what_for }}</strong>
                  </div>
                  <div class="col-12 col-md-3">
                    <div class="form-control-wrap form-control-currency">
                      <i class="fas fa-dollar-sign"></i>
                      <v-currency
                        :is-blank="false"
                        type="text"
                        class="form-control text-right"
                        name="invoice[amount]"
                        v-model="invoice.amount"
                      ></v-currency>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </template>
        </template>

        <template v-if="showManagementFees && managementFee > 0 && monthlyManagementFees.length">
          <div class="form-row">
            <div class="col-12">
              <div class="qb-label">QB Type</div>
            </div>
            <div class="col-12" v-for="(period, index) in temp.management_fees" :key="index">
              <div class="row align-items-center justify-content-between">
                <div class="col-auto">
                  <span v-html="generateQBSelectionField(`${period.name.replace(/\s/g, '_').toLowerCase()}`)"></span>
                  <strong>{{ period.name }} {{ mfPercentage }}</strong>
                </div>
                <div class="col-12 col-md-3">
                  <div class="form-control-wrap form-control-currency">
                    <i class="fas fa-dollar-sign"></i>
                    <input type="hidden" :name="`mmf_items[${index}][name]`" :value="period.name" />
                    <input type="hidden" :name="`mmf_items[${index}][start_date]`" :value="period.start_date" />
                    <input type="hidden" :name="`mmf_items[${index}][end_date]`" :value="period.end_date" />
                    <input type="hidden" :name="`mmf_items[${index}][type]`" value="management_fee" />
                    <v-currency
                      :is-blank="false"
                      type="text"
                      class="form-control text-right"
                      :name="`mmf_items[${index}][amount]`"
                      v-model="period.amount"
                    ></v-currency>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </template>

        <template v-if="showHotelManagementFees && temp.hotel_management_fees.length">
          <div class="form-row mt-5">
            <div class="col-12">
              <div class="qb-label">QB Type</div>
            </div>
            <div class="col-12" v-for="(period, index) in temp.hotel_management_fees" :key="index">
              <div class="row align-items-center justify-content-between">
                <button
                  type="button"
                  class="btn btn-danger btn-slim btn-sm mx-1 position-absolute"
                  style="right: 100%;"
                  @click="toggleField('hotel_management_fee', true)"
                  v-if="!invoice.is_management_fees"
                >
                  <i class="fa fa-times"></i>
                </button>
                <div class="col-auto col-md-9">
                  <span v-html="generateQBSelectionField(`${period.name.replace(/\s/g, '_').toLowerCase()}`)"></span>
                  <span
                    >{{ period.name }} (<v-currency
                      :is-blank="false"
                      type="text"
                      class="d-inline form-control text-right"
                      style="width: 10%;"
                      :name="`hotel_mmf_items[${index}][percentage]`"
                      v-model="period.percentage"
                      @input="calculatePercentage(period.percentage, index)"
                    ></v-currency
                    >%)</span
                  >
                </div>
                <div class="col-12 col-md-3">
                  <div class="form-control-wrap form-control-currency">
                    <i class="fas fa-dollar-sign"></i>
                    <input type="hidden" :name="`hotel_mmf_items[${index}][name]`" :value="period.name" />
                    <input type="hidden" :name="`hotel_mmf_items[${index}][start_date]`" :value="period.start_date" />
                    <input type="hidden" :name="`hotel_mmf_items[${index}][end_date]`" :value="period.end_date" />
                    <input type="hidden" :name="`hotel_mmf_items[${index}][type]`" value="hotel_management_fee" />
                    <v-currency
                      :is-blank="false"
                      type="text"
                      class="form-control text-right"
                      :name="`hotel_mmf_items[${index}][amount]`"
                      v-model="period.amount"
                    ></v-currency>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </template>

        <div class="form-row py-4" v-if="invoice.is_initial_invoice || showHotelManagementFees">
          <div class="dropdown" v-if="fields.every(f => !f.displayed)">
            <button
              class="btn btn-secondary btn-slim dropdown-toggle"
              type="button"
              id="addLineItem"
              data-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="false"
            >
              <i class="fas fa-plus"></i>
            </button>
            <div class="dropdown-menu p-0" aria-labelledby="addLineItem">
              <template v-for="field in fields">
                <button :key="field.key" v-if="!field.displayed" type="button" class="dropdown-item" @click="toggleField(field)">
                  {{ field.label }}
                </button>
              </template>
            </div>
          </div>
        </div>
      </div>

      <div class="col-12 col-md-6">
        <div class="form-row mb-2">
          <div class="col">
            <div class="form-group">
              <label class="form-control-wrap">Insurance Company</label>
              <div class="form-control-wrap">
                {{
                  adjusters.carrier_adjuster && adjusters.carrier_adjuster.company_data && adjusters.carrier_adjuster.company_data.name
                    ? adjusters.carrier_adjuster.company_data.name
                    : "-"
                }}
              </div>
            </div>
          </div>
        </div>

        <div class="form-row mb-2">
          <div class="col">
            <div class="form-group">
              <label class="form-control-wrap">Carrier Adjuster</label>
              <div class="form-control-wrap">
                {{
                  adjusters.carrier_adjuster && adjusters.carrier_adjuster.contact_data && adjusters.carrier_adjuster.contact_data.name
                    ? adjusters.carrier_adjuster.contact_data.name
                    : "-"
                }}
              </div>
            </div>
          </div>
        </div>

        <div class="form-row mb-2">
          <div class="col">
            <div class="form-group">
              <label class="form-control-wrap">Adjuster Preferences</label>
              <div class="form-control-wrap">
                {{
                  adjusters.carrier_adjuster &&
                  adjusters.carrier_adjuster.contact_data &&
                  adjusters.carrier_adjuster.contact_data.invoicing_preferences
                    ? adjusters.carrier_adjuster.contact_data.invoicing_preferences
                    : "-"
                }}
              </div>
            </div>
          </div>
        </div>

        <div class="form-row mb-2">
          <div class="col">
            <div class="form-group">
              <label class="form-control-wrap">Personal Negotiated Fees</label>
              <div class="form-control-wrap">
                {{
                  adjusters.carrier_adjuster && adjusters.carrier_adjuster.contact_data && adjusters.carrier_adjuster.contact_data.negotiated_fees
                    ? adjusters.carrier_adjuster.contact_data.negotiated_fees
                    : "-"
                }}
              </div>
            </div>
          </div>
        </div>

        <div class="form-row mb-2">
          <div class="col">
            <div class="form-group">
              <label class="form-control-wrap">Company Negotiated Fees</label>
              <div class="form-control-wrap">
                {{
                  adjusters.carrier_adjuster && adjusters.carrier_adjuster.company_data && adjusters.carrier_adjuster.company_data.negotiated_fees
                    ? adjusters.carrier_adjuster.company_data.negotiated_fees
                    : "-"
                }}
              </div>
            </div>
          </div>
        </div>

        <div class="form-row mb-2">
          <div class="col">
            <div class="form-group">
              <label class="form-control-wrap">Company Guidelines</label>
              <div class="form-control-wrap">
                {{
                  adjusters.carrier_adjuster && adjusters.carrier_adjuster.company_data && adjusters.carrier_adjuster.company_data.guidelines
                    ? adjusters.carrier_adjuster.company_data.guidelines
                    : "-"
                }}
              </div>
            </div>
          </div>
        </div>

        <div class="form-row mb-2">
          <div class="col">
            <div class="form-group">
              <label class="form-control-wrap">Fees Paid out of</label>
              <div class="form-control-wrap">
                {{ housing_fee_type }}
              </div>
            </div>
          </div>
        </div>

        <div class="form-row mb-2">
          <div class="col">
            <div class="form-group">
              <label class="form-control-wrap">Pays Electronically</label>
              <div class="form-control-wrap">
                {{ pays_directly }}
              </div>
            </div>
          </div>
        </div>

        <div class="form-row mb-2">
          <div class="col">
            <div class="form-group">
              <label class="form-control-wrap">Carrier will pay TPS Housing direct</label>
              <div class="form-control-wrap">
                {{ pays_electronically }}
              </div>
            </div>
          </div>
        </div>

        <div class="form-row mb-2">
          <div class="col">
            <div class="form-group">
              <label class="form-control-wrap">Accounting Notes</label>
              <div class="form-control-wrap">
                <textarea
                  spellcheck="true"
                  name="invoice[accounting_notes]"
                  rows="3"
                  class="form-control alphanumeric-field ruled-textarea"
                  v-model="invoice.accounting_notes"
                ></textarea>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-6">
        <div class="form-row mb-2">
          <div class="col-12">
            <div class="border-bottom d-flex justify-content-between">
              <strong>{{ invoice.is_initial_invoice ? "Invoice Total:" : "Invoice Amount:" }}</strong>
              <span class="float-right">${{ formatMoney(totalAmount) }}</span>
            </div>
          </div>
        </div>
        <div class="form-row mb-2 align-items-center">
          <div class="col-12">
            <p class="border-bottom d-flex">
              <strong class="text-nowrap">Invoice Number:</strong>
              <input
                style="outline: none;"
                class="w-100 border-0 text-right"
                type="text"
                name="invoice[invoice_number]"
                v-model="invoice.invoice_number"
              />
            </p>
          </div>
        </div>
      </div>
    </div>

    <a v-if="invoice.pdf_path" target="_blank" :href="`/${invoice.pdf_path}`">Download PDF</a>
  </form>
</template>
<script>
export default {
  props: ["invoice", "placement", "adjusters", "budget", "property", "hotel"],
  data() {
    return {
      fields: [],
      refreshMmf: 0,
      temp: { rents: [], management_fees: [], hotel_management_fees: [] },
      forceUpdate: { rent: false, management_fee: false }
    };
  },
  watch: {
    hotelManagementFees: {
      handler() {
        this.temp.hotel_management_fees = this.getReactiveFees("hotelManagementFees", "hotel_management_fee");
      },
      immediate: true
    },
    monthlyManagementFees: {
      handler() {
        this.temp.management_fees = this.getReactiveFees("monthlyManagementFees", "management_fee");
      },
      immediate: true
    },
    rentItems: {
      handler() {
        this.temp.rents = this.getReactiveFees("rentItems", "rent");
      },
      immediate: true
    }
  },
  methods: {
    getReactiveFees(key, type) {
      if (!this.forceUpdate[type] && this.invoice && this.invoice.line_items && this.invoice.line_items.length) {
        this.forceUpdate[type] = false;

        return this[key].map(item => {
          const lineItem = this.invoice.line_items.find(i => i.name === item.name && i.type === type);

          return {
            ...item,
            amount: lineItem ? this.realFloat(lineItem.amount) : 0
          };
        });
      }

      return this[key].map(period => ({ ...period }));
    },
    recalculateMmf() {
      if (this.invoice.created_from === "hotel_placement") return this.calculatePercentage();

      if (this.invoice.is_management_fees && this.budget.line_items && this.budget.line_items.length) {
        this.forceUpdate.management_fee = true;
        this.refreshMmf++;
        return;
      }

      if (!this.temp.rents.length) return;

      this.temp.rents.forEach((item, index) => this.calculateProrationAmount(item.start_date, item.end_date, index));
    },
    calculateDays(start_date, end_date) {
      try {
        const start = moment(start_date, "MM/DD/YYYY");
        const end = moment(end_date, "MM/DD/YYYY");
        const days = end.diff(start, "days") + 1;
        return isNaN(days) ? "0 days" : days + (days === 1 ? " day" : " days");
      } catch (error) {
        return "0 days";
      }
    },
    calculateMarkup(budget_markup) {
      let amount = 0;

      if (!budget_markup) return amount;

      switch (budget_markup.budget_markup_type_id) {
        case "1":
        case 1:
          amount = this.realFloat(budget_markup.amount);
          break;
        case "2":
        case 2:
          const markup_amount = this.realFloat(budget_markup.amount) / 100;
          amount = this.realFloat(this.leaseAndFhaRate * markup_amount);
          break;
        default:
          break;
      }

      return amount;
    },
    calculatePercentage(percent = 0, index = 0) {
      const managementFee = this.temp.hotel_management_fees[index] || {};
      const percentage = percent || managementFee.percentage || 0;
      const amount = (this.hotelTotal * this.realFloat(percentage)) / 100;

      if (this.temp.hotel_management_fees[index]) {
        this.temp.hotel_management_fees[index].amount = amount;
        this.forceUpdate.hotel_management_fee = true;
      }

      return amount;
    },
    calculateProrationAmount(start_date, end_date, index = null) {
      const periods = window.findPeriods(start_date, end_date);
      const amount = this.calculateRentAmount(periods);
      const rentAmount = this.formatMoney(amount, true);
      if (this.temp.rents[index]) {
        this.temp.rents[index].amount = rentAmount;
        this.forceUpdate.management_fee = true;
        this.refreshMmf++;
      }

      return rentAmount;
    },
    calculateRentAmount(periods) {
      let amount = 0;

      periods.forEach(period => {
        let diffDays = window.diffDays(period.start_date, period.end_date, this.isCorporate);
        amount += (this.leaseAndFhaRate / 30) * diffDays;
      });

      return amount;
    },
    realFloat(val) {
      return window.realFloat(val);
    },
    formatMoney(amount) {
      return window.formatMoney(amount);
    },
    getPaidOutof(id) {
      const paidOutof = app.options.paid_out_of.find(opt => opt.id == id);
      return paidOutof ? paidOutof.text : "-";
    },
    isAdded(key) {
      const field = this.fields.find(item => item.key === key);
      return field ? field.displayed : false;
    },
    toggleField(field, hide = false) {
      const fields = ["cleaning_fee", "application_fee", "pet_fee", "misc_fee", "landlord_deposit", "pet_deposit"];
      const depositFields = ["landlord_deposit", "pet_deposit", "furniture_deposit"];
      const furnitureFields = ["furniture_delivery_fee", "furniture_cleaning_fee"];

      if (typeof field === "string") field = this.fields.find(item => item.key === field);

      field.displayed = field.key !== "rent" && !hide;

      if (fields.includes(field.key)) this.budget[`${field.key}_first_payment`] = !hide;
      if (depositFields.includes(field.key)) this.updateDepositConditionals(field.key, hide);
      if (field.key === "one_time_management_fee") this.budget.one_time = !hide;
      if (field.key === "one_time_admin_fee") this.budget.one_time_tps = !hide;
      if (hide && furnitureFields.includes(field.key)) this.budget[field.key] = 0;

      if (field.key === "rent") {
        const date = moment().format("MM/DD/YYYY");
        const data = {
          name: "Rent",
          amount: this.calculateProrationAmount(date, date),
          start_date: date,
          end_date: date,
          type: "rent"
        };

        if (this.temp.rents && this.temp.rents.length) {
          this.temp.rents.push(data);
        } else {
          this.temp.rents = [data];
        }
      }

      if (field.key === "hotel_management_fee") {
        if (hide) return (this.temp.hotel_management_fees = []);

        const date = moment().format("MM/DD/YYYY");
        const data = {
          name: "TPS Housing Admin Fee",
          amount: 0,
          start_date: date,
          end_date: date,
          type: "hotel_management_fee"
        };

        if (this.temp.hotel_management_fees && this.temp.hotel_management_fees.length) {
          this.temp.hotel_management_fees.push(data);
        } else {
          this.temp.hotel_management_fees = [data];
        }
      }
    },
    updateDepositConditionals(field, hide = false) {
      this.budget[`${field.replace("_deposit", "")}_paid_out_of`] = null;
      if (field === "furniture_deposit") this.budget[`${field}_enable`] = !hide;
    },
    removeAdditionalLineItem(index) {
      this.temp.rents.splice(index, 1);
    },
    generateQBSelectionField(name) {
      const qb_types = [1, 2, 3, 4, 5, 6, 7, 8, 99];

      return `<select class="qb-select" placeholder="QB Type" name="qb_type_${name}">
          ${qb_types
            .map(
              qb =>
                `<option value="${qb}" ${
                  this.invoice.qb_types && this.invoice.qb_types.some(qb_type => qb_type.what_for === name && qb_type.type === qb) ? "selected" : ""
                }>${qb}</option>`
            )
            .join("")}
        </select>`;
    }
  },
  computed: {
    action() {
      const property_id = this.property && this.property.id ? `&property_id=${this.property.id}` : "";
      const invoice_id = this.invoice && this.invoice.id ? `&invoice_id=${this.invoice.id}` : "";
      return `/api/invoice_action?log=1${property_id}${invoice_id}`;
    },
    isCorporate() {
      return this.property && this.property.lease_detail && this.property.lease_detail.lease_rate_type === "Daily";
    },
    isRentFromStatus() {
      return this.invoice.created_from === "status" && this.invoice.what_for === "Rent";
    },
    housing_fee_type() {
      if (this.adjusters.carrier_adjuster && this.adjusters.carrier_adjuster.company_data) {
        const housing_fee_type = app.options.housing_fee_types.find(i => i.id == this.adjusters.carrier_adjuster.company_data.housing_fee_type_id);
        return housing_fee_type ? housing_fee_type.text : "-";
      }

      return "-";
    },
    pays_directly() {
      if (this.adjusters.carrier_adjuster && this.adjusters.carrier_adjuster.company_data) {
        const pays_directly = app.options.confirm_extra.find(i => i.id == this.adjusters.carrier_adjuster.company_data.pays_directly);
        return pays_directly ? pays_directly.text : "-";
      }

      return "-";
    },
    pays_electronically() {
      if (this.adjusters.carrier_adjuster && this.adjusters.carrier_adjuster.company_data) {
        const pays_electronically = app.options.confirm_extra.find(i => i.id == this.adjusters.carrier_adjuster.company_data.pays_electronically);
        return pays_electronically ? pays_electronically.text : "-";
      }

      return "-";
    },
    feesAndDeposits() {
      const feesAndDeposits = {
        cleaning_fee: this.budget.cleaning_fee_first_payment ? this.realFloat(this.budget.cleaning_fee) : 0,
        application_fee: this.budget.application_fee_first_payment ? this.realFloat(this.budget.application_fee) : 0,
        pet_fee: this.budget.pet_fee_first_payment ? this.realFloat(this.budget.pet_fee) : 0,
        misc_fee: this.budget.misc_fee_first_payment ? this.realFloat(this.budget.misc_fee) : 0,
        furniture_cleaning_fee: this.budget.furniture_cleaning_fee ? this.realFloat(this.budget.furniture_cleaning_fee) : 0,
        furniture_delivery_fee: this.budget.furniture_delivery_fee ? this.realFloat(this.budget.furniture_delivery_fee) : 0,
        one_time_management_fee: this.budget.one_time ? this.realFloat(this.budget.one_time_fee) : 0,
        one_time_admin_fee: this.budget.one_time_tps ? this.realFloat(this.budget.one_time_tps_fee) : 0
      };

      return feesAndDeposits;
    },
    hasFees() {
      const keys = Object.keys(this.feesAndDeposits);
      return keys.some(key => this.feesAndDeposits[key] > 0) || this.fields.some(field => keys.includes(field.key) && field.displayed);
    },
    deposits() {
      if (!this.budget) return { landlord: 0, pet: 0, furniture: 0 };

      const landlordPaidOutOf = this.budget.landlord_paid_out_of == "1" || this.budget.landlord_paid_out_of == "3";
      const petPaidOutOf = this.budget.pet_paid_out_of == "1" || this.budget.pet_paid_out_of == "3";
      const furniturePaidOutOf = this.budget.furniture_paid_out_of == "1" || this.budget.furniture_paid_out_of == "3";

      if (this.invoice.is_initial_deposit) {
        return {
          landlord:
            this.budget.landlord_paidby_id != 1 && this.budget.landlord_deposit_first_payment && landlordPaidOutOf
              ? this.realFloat(this.budget.landlord_deposit)
              : 0,
          pet: this.budget.pet_paidby_id != 1 && this.budget.pet_deposit_first_payment && petPaidOutOf ? this.realFloat(this.budget.pet_deposit) : 0,
          furniture:
            this.budget.furniture_paidby_id != 1 && this.budget.furniture_deposit_enable && furniturePaidOutOf
              ? this.realFloat(this.budget.furniture_deposit)
              : 0
        };
      }

      return {
        landlord:
          this.budget.landlord_paidby_id != 1 && this.budget.landlord_deposit_first_payment && !landlordPaidOutOf
            ? this.realFloat(this.budget.landlord_deposit)
            : 0,
        pet: this.budget.pet_paidby_id != 1 && this.budget.pet_deposit_first_payment && !petPaidOutOf ? this.realFloat(this.budget.pet_deposit) : 0,
        furniture:
          this.budget.furniture_paidby_id != 1 && this.budget.furniture_deposit_enable && !furniturePaidOutOf
            ? this.realFloat(this.budget.furniture_deposit)
            : 0
      };
    },
    hasDeposits() {
      return (
        this.deposits.landlord ||
        this.deposits.pet ||
        this.deposits.furniture ||
        this.fields.some(field => field.key === "landlord_deposit" && field.displayed) ||
        this.fields.some(field => field.key === "pet_deposit" && field.displayed) ||
        this.fields.some(field => field.key === "furniture_deposit" && field.displayed)
      );
    },
    rentAmount: {
      get() {
        return this.isRentFromStatus ? this.invoice.amount - this.managementFee : this.budget.pro_rated_rent;
      },
      set(val) {
        this.invoice.amount = this.realFloat(val) + this.managementFee;
      }
    },
    pro_rated_month() {
      try {
        const month = moment(this.budget.pro_rated_start_date, "MM/DD/YYYY").format("MMMM YYYY");
        return month === "Invalid date" ? "" : month;
      } catch (error) {
        return "";
      }
    },
    next_month() {
      try {
        const month = moment(this.budget.next_month_start_date, "MM/DD/YYYY").format("MMMM YYYY");
        return month === "Invalid date" ? "Next Month" : month;
      } catch (error) {
        return "Next Month";
      }
    },
    leaseAndFhaRate() {
      return this.realFloat(this.budget.unfurnished_rent) + this.realFloat(this.budget.fha_package);
    },
    itemsTotal() {
      let total = 0;

      const keys = [
        "cleaning_fee",
        "pet_fee",
        "application_fee",
        "misc_fee",
        "landlord_deposit",
        "pet_deposit",
        "furniture_deposit",
        "furniture_cleaning_fee",
        "furniture_delivery_fee",
        "one_time_fee",
        "one_time_tps_fee"
      ];

      for (let key of keys) {
        switch (key) {
          case "cleaning_fee":
          case "pet_fee":
          case "application_fee":
          case "misc_fee":
            if (this.budget[key + "_first_payment"]) total += this.realFloat(this.budget[key]);
            break;
          case "landlord_deposit":
          case "pet_deposit":
          case "furniture_deposit":
            total += this.deposits[key.replace("_deposit", "")];
            break;
          case "one_time_fee":
            if (this.budget.one_time) total += this.realFloat(this.budget[key]);
            break;
          case "one_time_tps_fee":
            if (this.budget.one_time_tps) total += this.realFloat(this.budget[key]);
            break;
          default:
            total += this.realFloat(this.budget[key]);
            break;
        }
      }

      const rents = this.temp.rents ? this.temp.rents.reduce((total, rent) => total + this.realFloat(rent.amount), 0) : 0;

      return total + rents;
    },
    hotelTotal() {
      return this.invoice.invoice_requests ? this.invoice.invoice_requests.reduce((total, ir) => total + this.realFloat(ir.amount), 0) : 0;
    },
    totalAmount() {
      const managementFees =
        this.showManagementFees && this.temp.management_fees
          ? this.temp.management_fees.reduce((total, period) => total + this.realFloat(period.amount), 0)
          : 0;

      if (this.isRentFromStatus) {
        const rents = this.temp.rents ? this.temp.rents.reduce((total, rent) => total + this.realFloat(rent.amount), 0) : 0;
        return this.realFloat(rents) + this.realFloat(managementFees);
      }

      if (this.invoice.created_from === "hotel_placement") {
        const managementFees = this.temp.hotel_management_fees.reduce((total, mf) => total + this.realFloat(mf.amount), 0);
        return this.invoice.is_management_fees ? managementFees : this.hotelTotal + managementFees;
      }

      if (this.invoice.is_initial_deposit) return this.deposits.landlord + this.deposits.pet + this.deposits.furniture;
      if (this.invoice.is_management_fees) return managementFees;

      return this.realFloat(this.invoice.is_initial_invoice ? this.itemsTotal : this.invoice.amount) + managementFees;
    },
    markup() {
      const [markup] = this.budget && this.budget.budget_markups ? this.budget.budget_markups : [];
      return markup;
    },
    managementFee() {
      if (!this.showManagementFees || !this.markup) return 0;
      if (this.markup.budget_frequency_type === "Daily") return this.calculateMarkup(this.markup) * 30;

      return this.calculateMarkup(this.markup);
    },
    mfPercentage() {
      return this.markup && this.markup.budget_markup_type_id == 2 ? `(${this.realFloat(this.markup.amount)}%)` : "";
    },
    monthlyManagementFees() {
      this.refreshMmf;
      if (!this.budget) return [];

      let arr = this.temp.rents.length ? this.temp.rents : this.invoice.line_items.filter(i => i.type === "management_fee");

      if (this.invoice.is_management_fees && this.budget.line_items && this.budget.line_items.length && this.forceUpdate.management_fee) {
        arr = this.budget.line_items.filter(item => item.type === "rent");
      }

      return arr
        .reduce((managementFees, rent) => {
          const proRated = window.findMonthPeriods(rent.start_date, rent.end_date, this.managementFee, this.isCorporate);
          return [...managementFees, ...proRated];
        }, [])
        .reduce((managementFees, rent) => {
          const existing = managementFees.find(item => item.name === rent.name);
          if (existing) {
            existing.amount += rent.amount;
          } else {
            managementFees.push(rent);
          }

          return managementFees;
        }, [])
        .map(period => ({ ...period, type: "management_fee", name: `${period.name} Management Fee` }));
    },
    showManagementFees() {
      return (
        (this.invoice.is_management_fees && this.housing_fee_type === "Expenses") ||
        (this.invoice.is_initial_invoice && this.housing_fee_type !== "Expenses") ||
        (this.isRentFromStatus && this.housing_fee_type !== "Expenses")
      );
    },
    showHotelManagementFees() {
      return (
        (this.invoice.created_from === "hotel_placement" && this.housing_fee_type === "Expenses" && this.invoice.is_management_fees) ||
        (this.invoice.created_from === "hotel_placement" && this.housing_fee_type !== "Expenses")
      );
    },
    hotelManagementFees() {
      if (this.invoice.created_from !== "hotel_placement") return [];

      const items = this.invoice.line_items.filter(i => i.type === "hotel_management_fee");

      return items;
    },
    rentItems() {
      if (!this.budget) return [];

      const items = this.invoice.line_items.filter(i => i.type === "rent");

      return items;
    }
  },
  mounted() {
    if (this.invoice.is_initial_invoice) {
      this.fields = [
        { key: "rent", label: "Rent", displayed: false },
        { key: "cleaning_fee", label: "Lease Cleaning Fee", displayed: this.feesAndDeposits.cleaning_fee > 0 },
        { key: "application_fee", label: "Lease App Fee", displayed: this.feesAndDeposits.application_fee > 0 },
        { key: "pet_fee", label: "Lease Pet Fee", displayed: this.feesAndDeposits.pet_fee > 0 },
        { key: "misc_fee", label: "Misc Fees", displayed: this.feesAndDeposits.misc_fee > 0 },
        { key: "furniture_cleaning_fee", label: "Furniture Cleaning Fee", displayed: this.feesAndDeposits.furniture_cleaning_fee > 0 },
        { key: "furniture_delivery_fee", label: "Furniture Delivery Fee", displayed: this.feesAndDeposits.furniture_delivery_fee > 0 },
        { key: "one_time_admin_fee", label: "TPS One Time Admin Fee", displayed: this.feesAndDeposits.one_time_admin_fee > 0 },
        { key: "one_time_management_fee", label: "One Time Management Fee", displayed: this.feesAndDeposits.one_time_management_fee > 0 },
        { key: "landlord_deposit", label: "Property Deposit", displayed: this.deposits.landlord > 0 },
        { key: "pet_deposit", label: "Pet Deposit", displayed: this.deposits.pet > 0 },
        { key: "furniture_deposit", label: "Furniture Deposit", displayed: this.deposits.furniture > 0 }
      ];
    }
    if (this.invoice.created_from === "hotel_placement") {
      this.fields = [{ key: "hotel_management_fee", label: "Hotel Management Fee", displayed: this.hotelManagementFees.length > 0 }];
    }
    $(".recalculate-mmf").tooltip("enable");
  }
};
</script>

<style>
.swal2-content {
  z-index: 2;
}
</style>



// WEBPACK FOOTER //
// resources/assets/js/components/placement/invoice-action.vue